
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from 'styles/news.module.css';
import classNames from 'classnames/bind';
import AnnouncementDetailCard from 'components/news/announcementDetail/AnnouncementDetailCard';
const cx = classNames.bind(styles);
function detail() {
    return (<div className={cx('container')}>
      <AnnouncementDetailCard />
    </div>);
}
export default detail;

    async function __Next_Translate__getServerSideProps__197785481e2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/announcement/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__197785481e2__ as getServerSideProps }
  